import React, { Fragment } from 'react';
import Moment from 'moment';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import styled from '../styled';
import { DATE_FORMATS } from 'src/constants/constants';

const styles = theme => ({
  root: {},
  header: {
    marginBottom: '0.5em',
    textAlign: 'left',
    backgroundColor: '#24242E',
    position: 'relative',
    padding: '8px 16px 16px 16px',
    height: '56px',
  },
  monthHeader: {
    textAlign: 'left',
    backgroundColor: '#24242E',
    position: 'relative',
    padding: '8px 16px 16px 16px',
  },
  dayweek: {
    display: 'flex',
    width: '100%',
    paddingTop: '10px',
    justifyContent: 'space-between',
  },
  dayweekItem: {
    fontSize: '12px',
    textAlign: 'center',
    color: '#FFF',
    width: '24px',
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  monthSelect: {},
  moreButton: {
    border: 'none',
    background: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    cursor: 'pointer',
    color: '#FFF',
    paddingRight: '7px',
  },
});

class DatePickerHeader extends React.Component {
  static propTypes = {};

  getYears = (from, to, value, defaultYear) => {
    const years = [];
    const currentYear = Moment().year();
    const fromMonth = Moment([currentYear, 0]);
    const toMonth = Moment([currentYear + 5, 11]);
    if (from && from !== '' && to && to !== '') {
      if (value !== '' && Moment(value).year() > Moment([to, 0, 1]).year()) {
        for (let i = parseInt(Moment(from).year(), 10); i <= parseInt(Moment(value).year(), 10); i += 1) {
          years.push(i);
        }
      } else if (value === '' && defaultYear !== '' && Moment([defaultYear, 0, 1]).year() > Moment([to, 0, 1]).year()) {
        for (let i = parseInt(Moment(from).year(), 10); i <= parseInt(Moment([defaultYear, 0, 1]).year(), 10); i += 1) {
          years.push(i);
        }
      } else {
        if (navigator.userAgent.search('Firefox') >= 0) {
          for (let i = parseInt(Moment(from).year(), 10) * -1; i <= parseInt(Moment(to).year(), 10) * -1; i += 1) {
            years.push(i);
          }
        } else {
          for (let i = parseInt(Moment(from.toString()).year(), 10); i <= parseInt(Moment(to.toString()).year(), 10); i += 1) {
            years.push(i);
          }
        }
      }
    } else {
      for (let i = fromMonth.year() - 20; i <= toMonth.year(); i += 1) {
        years.push(i);
      }
    }
    return years;
  };

  render() {
    const { classes, pickerRef, from, to, monthRange, defaultYear, value, hideMonthDropdown, hideWeekDays } = this.props;
    const monthsData = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const months = monthRange && monthRange.from === monthRange.to ? monthsData.slice(monthRange.from, monthRange.to + 1) : monthsData;

    const years = this.getYears(from, to, value, defaultYear);

    let date = value || Moment().toDate();

    if (defaultYear && value === '') {
      date = Moment([defaultYear, 0, 1]).toDate();
    }

    /* update header if a user moves left/right */
    const month = pickerRef.date;
    const headerDate = Moment(month).format(DATE_FORMATS.DISPLAY_DATE_ONLY);

    if (value !== headerDate) {
      date = month;
    }

    return (
      <div className={hideMonthDropdown ? classes.monthHeader : classes.header}>
        <div className={classes.actionBar}>
          <div className={classes.monthSelect}>
            {!hideMonthDropdown && (
              <select
                name="month"
                aria-label="Select month"
                onChange={({ target: { value } }) => {
                  pickerRef.changeMonth(value);
                }}
                value={date.getMonth()}>
                {months.map((month, i) => (
                  <option key={month} value={i}>
                    {month}
                  </option>
                ))}
              </select>
            )}
            <select
              name="year"
              aria-label="Select year"
              onChange={({ target: { value } }) => pickerRef.changeYear(value)}
              value={date.getFullYear()}>
              {years.map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          {!hideMonthDropdown && (
            <Fragment>
              <button
                aria-label="Press enter to navigate to previous month"
                className={classes.moreButton}
                type="button"
                onClick={pickerRef.decreaseMonth}>
                <NavigateBeforeIcon />
              </button>
              <button
                aria-label="Press enter to navigate to next month"
                className={classes.moreButton}
                type="button"
                onClick={pickerRef.increaseMonth}>
                <NavigateNextIcon />
              </button>
            </Fragment>
          )}
          {hideMonthDropdown && (
            <Fragment>
              <button
                aria-label="Press enter to navigate to previous year"
                className={classes.moreButton}
                type="button"
                onClick={pickerRef.decreaseYear}>
                <NavigateBeforeIcon />
              </button>
              <button
                aria-label="Press enter to navigate to next year"
                className={classes.moreButton}
                type="button"
                onClick={pickerRef.increaseYear}>
                <NavigateNextIcon />
              </button>
            </Fragment>
          )}
        </div>

        {!hideWeekDays && (
          <div className={classes.dayweek}>
            <div className={classes.dayweekItem}>S</div>
            <div className={classes.dayweekItem}>M</div>
            <div className={classes.dayweekItem}>T</div>
            <div className={classes.dayweekItem}>W</div>
            <div className={classes.dayweekItem}>T</div>
            <div className={classes.dayweekItem}>F</div>
            <div className={classes.dayweekItem}>S</div>
          </div>
        )}
      </div>
    );
  }
}

export default styled(DatePickerHeader)(styles);
